import { CurrentUser } from "../redux/slices/currentUserSlice";

/**
 * Use this to check if a user is the support user. Prefer this over directly
 * comparing a user's email with SUPPORT_USER_EMAIL, unless you only have access
 * to the email string (e.g. when handling login).
 */
export function isSupportUser(currentUser: CurrentUser | null): boolean {
  return (
    currentUser?.id != null &&
    currentUser?.org?.supportUserId === currentUser.id
  );
}
